export const css = {
	root: 'kGbL1oRp',
	title: 'IJQ8JBMn',
	body: '_1CYLU3Bg',
	warning: 'peNydINr',
	' _key': 'apic-theme/apic/learning-activity/activity'
};

export default css;
